const ReadingMask = () => {
  return (
    <svg
      width="96"
      height="92"
      viewBox="0 0 96 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="95.8548" height="92" rx="46" />
      <g clipPath="url(#clip0_150_3579)">
        <path
          d="M68.8762 62.5656C68.8762 66.3611 68.8328 69.7065 68.8762 73.0411C68.9196 75.3997 67.9978 76.4571 65.5036 76.4408C54.1244 76.3649 42.7379 76.3649 31.3442 76.4408C28.85 76.4408 27.9553 75.4214 28.0258 73.0303C28.1234 69.6252 28.0258 66.2201 28.0258 62.5656C25.6238 62.5656 23.5688 62.6144 21.5193 62.5656C18.1575 62.468 16.0538 60.516 16.0104 57.176C15.9236 50.2212 15.9236 43.2664 16.0104 36.3116C16.0592 32.9011 18.0708 31.0576 21.503 30.9817C23.5634 30.9329 25.6238 30.9817 28.0421 30.9817C28.0421 27.0777 28.0421 23.3907 28.0421 19.7253C28.0421 16.6347 28.5843 16.0599 31.6695 16.0599C42.8662 16.0599 54.0629 16.087 65.2867 16.022C67.846 16.022 68.9087 17.0739 68.8599 19.5789C68.8003 23.2659 68.8599 26.953 68.8599 30.9654C71.2402 30.9654 73.382 30.9166 75.5183 30.9654C78.8746 31.063 80.7019 32.8577 80.729 36.2303C80.7832 43.1814 80.7832 50.1344 80.729 57.0892C80.7019 60.5431 78.7987 62.4409 75.3719 62.5439C73.3332 62.6252 71.2673 62.5656 68.8762 62.5656ZM76.5431 35.2597H43.5114C36.5603 35.2597 29.6073 35.2597 22.6525 35.2597C21.4434 35.2597 20.3101 35.1567 20.3318 36.9948C20.3969 43.5014 20.3318 50.0079 20.4077 56.5145C20.4077 57.0892 21.1289 58.1411 21.5789 58.1411C23.6827 58.32 25.8082 58.2224 28.0855 58.2224C28.0855 56.3681 28.1831 54.9258 28.0855 53.5052C27.8848 51.0815 28.8662 50.0459 31.3387 50.0621C42.8011 50.1127 54.2671 50.1127 65.7368 50.0621C68.0629 50.0621 69.0171 51.1086 68.9195 53.3642C68.8491 54.9421 68.9195 56.5253 68.9195 58.2441C70.9492 58.3223 72.9815 58.297 75.0086 58.1682C75.3711 58.0561 75.6995 57.8542 75.963 57.5812C76.2266 57.3082 76.4168 56.9729 76.516 56.6066C76.5864 49.6717 76.5431 42.7314 76.5431 35.2597ZM64.3812 71.8428V54.5788H32.3527V71.8428H64.3812ZM32.3581 30.8407H64.43V20.723H32.3581V30.8407Z"
          fill="black"
        />
        <path
          d="M48.6763 61.9042C45.7103 61.9042 42.7119 62.0614 39.7839 61.812C38.8134 61.7307 37.9296 60.5921 37.0078 59.936C37.9187 59.1606 38.808 57.7671 39.7189 57.7237C45.5585 57.5177 51.409 57.5285 57.2486 57.7237C58.1433 57.7508 59 59.0576 59.8784 59.7733C59.0108 60.4836 58.1975 61.7198 57.2757 61.8066C54.4454 62.0831 51.5554 61.8988 48.6763 61.9042Z"
          fill="black"
        />
        <path
          d="M48.6693 64.4955H57.0736C58.5701 64.4955 60.0775 64.9455 59.7847 66.6643C59.6437 67.4885 58.1201 68.638 57.1929 68.6705C51.4183 68.8549 45.6383 68.8711 39.8692 68.6705C38.8932 68.638 37.966 67.277 37.0117 66.5288C38.0148 65.8619 38.9745 64.7124 40.0319 64.6148C42.8785 64.322 45.7847 64.5009 48.6693 64.4955Z"
          fill="black"
        />
        <rect
          x="18.8164"
          y="34.3101"
          width="60.5637"
          height="25.3522"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_150_3579">
          <rect
            width="64.7891"
            height="60.4405"
            fill="white"
            transform="translate(16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReadingMask;
